<template>
    <div class="metro-box-wrapper">
        <div class="heading">
            <h3>Información de pago</h3>
        </div>
        <div class="content">
            <div id="paymentOption" class="payment-option-wrapper">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="radio-block font-icon-radio">
                            <input id="payments1" v-model="selected" name="payments" type="radio" class="radio"
                                   value="paymentsCreditCard"/>
                            <label class="" for="payments1"><span>Tarjeta de Crédito</span> <img
                                    src="http://www.nndrilling.com/userfiles/ckfiles/images/creditcard-icons.png"
                                    alt="Image" style="width:9em;"></label>
                        </div>
                    </div>
                    <div class="clear mb-10"></div>
                    <div class="col-sm-12">
                        <div class="radio-block font-icon-radio">
                            <input id="payments2" v-model="selected" name="payments" type="radio" class="radio"
                                   value="paymentPaypal"/>
                            <label class="" for="payments2"><span>Paypal</span> <img
                                    src="https://cdn.worldvectorlogo.com/logos/paypal.svg"
                                    alt="Image" style="width:6em;"></label>
                        </div>
                    </div>
                </div>
                <div id="paymentsCreditCard" v-if="selected==='paymentsCreditCard'" class="payment-option-form">
                    <div class="inner">
                        <h4 class="mb-20">Tu pago total es de: 7.00€</h4>
                        <p>El importe de la reserva se debitará de su tarjeta de crédito una vez que se haya completado
                            la reserva</p>
                        <div class="form-horizontal">
                            <stripe-checkout
                                    :options="options"
                                    button="Pagar Reserva"
                                    stripe-key="pk_test_zScsLe1gkMbY0uXp3wxCTbRk"
                                    :product="product">
                            </stripe-checkout>
                        </div>
                    </div>
                </div>
                <div id="paymentPaypal" v-if="selected==='paymentPaypal'" class="payment-option-form">
                    <div class="inner">
                        <h4 class="mb-20">Tu pago total es de: 7.00€</h4>
                        <p>El importe de la reserva se debitará de su tarjeta de crédito una vez que se haya completado
                            la reserva</p>
                        <p>Despues de hacer click en Reservar, seras redirigido a Paypal para completar el pago. Si no
                            completas el proceso no se confirmará la reserva. Al terminar, serás redirigido de nuevo a
                            Carbnp</p>
                        <router-link to="/confirmation"><input type="submit" class="btn btn-secundary"
                                                               value="Pagar con Paypal"></router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import image from '../../assets/images/colibri.png';

    export default {
        name: "paymentForm",
        data() {
            return {
                selected: "",
                coupon: "",
                product: {
                    name: 'VolaRooms',
                    description: '2h reserva de Vola Room',
                    amount: 700
                },
                options: {
                    image: image,
                    locale: 'auto',
                    currency: 'EUR'
                }
            }
        },
    }
</script>

<style scoped>
    .btn-stripe-checkout {
        background: #8ac6c4 !important;
    }
</style>